import { List, ListItem } from "@mui/material";
import React, { FC } from "react";

import { Stack, Typography } from "@components/base";

interface TooltipContentProps {
  title: string;
  points: string[];
}

const TooltipContent: FC<TooltipContentProps> = ({ title, points }) => (
  <Stack gap={1}>
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {title}
    </Typography>
    <List
      sx={{
        padding: 0,
        listStyleType: "disc",
        pl: 2,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {points.map((point, index) => (
        <ListItem
          key={index}
          sx={{
            display: "list-item",
            padding: 0,
          }}
        >
          <Typography variant="body2">{point}</Typography>
        </ListItem>
      ))}
    </List>
  </Stack>
);

export default TooltipContent;
